import {
  AppInputNumber,
  AppRemixIcon,
  AppTextArea,
} from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import Translator from '../../../../../../components/helpers/Translator';
import colors from '../../../../../../../constants/colors';
import { toFormData } from '../../../../../../../minions/forms';
import errorHandler from '@/layout/components/error/ErrorHandler';

const CorrectiveActionsEditTaskUpdateCalcs = (props) => {
  const {
    plantObligationID,
    onCreated,
    modulePermissions,
    selectedTask,
    selectedTaskUpdate,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();

  // < EDIT TASK UPDATE CALCS
  const handleEditTaskUpdateCalcs = async (values) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_taskUpdate_edit_calcs"
        ),
        toFormData({
          ...values,
          ...{
            moduleBridgeHex,
            plantHex,
            plantObligationID,
            taskID: selectedTask.id,
            taskUpdateID: selectedTaskUpdate.id,
          },
        }),
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch(
        currentPageAction.change(
          'correctiveActionsTabs',
          { [plantObligationID]: response.data },
          true
        )
      );
      onCreated();
    } catch (err) {
      dispatch(errorHandler(err));
    }
  };
  // > EDIT TASK UPDATE CALCS

  const validationSchema = Yup.object().shape({
    implantation: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
    efficacy: Yup.mixed().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
  });

  return (
    <div style={{ borderTop: `1px solid ${colors.grey300}` }} className="pt-2">
      <Formik
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        initialValues={{
          implantation: selectedTaskUpdate.settings?.implantation || '0.00',
          implantationComment:
            selectedTaskUpdate.settings?.implantationComment || '',
          efficacy: selectedTaskUpdate.settings?.efficacy || '0.00',
          efficacyComment: selectedTaskUpdate.settings?.efficacyComment || '',
        }}
        onSubmit={handleEditTaskUpdateCalcs}
      >
        {({ setFieldValue, handleSubmit, values, isSubmitting, errors }) => (
          <>
            <div className="row-no-margin">
              {modulePermissions?.caAutoCalc &&
                modulePermissions.caAutoCalc == 1 && (
                  <div className="row">
                    <div className="col-lg-6 pt-2">
                      <AppInputNumber
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="implantation"
                          />
                        )}
                        value={values.implantation}
                        icon={<AppRemixIcon icon="calendar" />}
                        onChange={(v) => setFieldValue('implantation', v)}
                        decimals={2}
                      />
                      <AppTextArea
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="implantation.comment"
                          />
                        )}
                        icon={<AppRemixIcon icon="chat-4" />}
                        onChange={(v) =>
                          setFieldValue('implantationComment', v)
                        }
                        value={values?.implantationComment}
                      />
                    </div>
                    <div className="col-lg-6 pt-2">
                      <AppInputNumber
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-correctiveActions"
                            name="efficacy"
                          />
                        )}
                        value={values.efficacy}
                        icon={<AppRemixIcon icon="calendar" />}
                        onChange={(v) => setFieldValue('efficacy', v)}
                        decimals={2}
                      />
                      <AppTextArea
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="efficacy.comment"
                          />
                        )}
                        icon={<AppRemixIcon icon="chat-4" />}
                        onChange={(v) => setFieldValue('efficacyComment', v)}
                        value={values?.efficacyComment}
                      />
                    </div>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <div className="float-right">
                    <span
                      className="btn btn-outline-light mr-2"
                      onClick={() => onCreated()}
                    >
                      <Translator file="user" name="user.cancel" />
                    </span>
                    <span
                      className="btn btn-outline-info"
                      onClick={handleSubmit}
                    >
                      <Translator file="general" name="general.update" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};
export default CorrectiveActionsEditTaskUpdateCalcs;
